module.exports = __webpack_public_path__ + "img/icon-presentation-live.40090570.png";